export const GUIDE_IO_ROOT_PATH = '/interactive-onboarding'
export const GUIDE_IO_PROJECT_PATH = `${GUIDE_IO_ROOT_PATH}/:projectUrlName?/:stepKey?`
